<!-- <button *ngIf="taskList.length > 1" class="button is-primary is-small" (click)="toggleCheckboxes()"><i class="fas fa-cogs"></i></button>
<button *ngIf="showSummaryOptions" class="button is-primary summary-button" (click)="startSummmaryTask()">Summarize</button> -->

<div
  id="task-list"
  class="content card-content overflow task-list-checkbox-hidden"
  *ngIf="taskList && taskList.length > 0"
>
  <div class="list is-hoverable">
    <a
      *ngFor="let task of taskList"
      class="list-item mb-1"
      [class.is-active]="task.token === token"
    >
      <div *ngIf="!task.info.startedAt">
        <p>
          <span class="is-capitalized"
            ><i
              class="fa"
              [class.fa-capsules]="task.info.target === 'drug'"
              [class.fa-crosshairs]="task.info.target === 'drug-target'"
              [class.fa-tasks]="task.info.target === 'summarize'"
            >
          </i>

            {{ algorithmNames[task.info.algorithm] }}
            </span>
          <span class="icon is-pulled-right"
            ><i class="fas fa-pause" aria-hidden="true"></i
          ></span>
        </p>
        <p>
          <small
            *ngIf="task.stats.queueLength > 0 && task.stats.queuePosition === 1"
          >
            Queued: 1 other task to finish
          </small>
          <small
            *ngIf="task.stats.queueLength > 0 && task.stats.queuePosition > 1"
          >
            Queued: {{ task.stats.queuePosition }} other tasks to finish
          </small>
          <small
            *ngIf="
              task.stats.queueLength === 0 || task.stats.queuePosition === 0
            "
          >
            Execution imminent...
          </small>
          <a (click)="analysis.removeTask(task.token)" class="has-text-danger">
            <span class="icon is-pulled-right">
              <i class="fa fa-trash"></i>
            </span>
          </a>
        </p>
      </div>
      <div *ngIf="!task.info.done && !task.info.failed && task.info.startedAt">
        <p>
          <span class="is-capitalized"
            ><i
              class="fa"
              [class.fa-capsules]="task.info.target === 'drug'"
              [class.fa-crosshairs]="task.info.target === 'drug-target'"
              [class.fa-tasks]="task.info.target === 'summarize'"
            ></i>
            {{ algorithmNames[task.info.algorithm] }}</span
          >
          <span class="icon is-pulled-right"
            ><i class="fas fa-spinner fa-spin" aria-hidden="true"></i
          ></span>
        </p>
        <p>
          <small>Started {{ task.info.startedAt | date: "short" }}</small>
          <a
            (click)="analysis.removeTask(task.token)"
            class="is-pulled-right has-text-danger"
          >
            <span class="icon is-pulled-right">
              <i class="fa fa-trash"></i>
            </span>
          </a>
        </p>
        <progress
          class="progress is-success"
          [value]="task.info.progress * 100"
          max="100"
        ></progress>
      </div>
      <div
        class="has-tooltip-bottom"
        *ngIf="task.info.done"
        data-tooltip-="Show analysis results"
      >
        <div class="columns">
          <div class="column is-2 task-list-checkbox">
            <input [checked]="taskCheckboxes.has(task.token)" type="checkbox" name="summarize" value="summmarize_check" (change)="addToTaskSelection($event, task.token)" />
          </div>

          <div class="column" (click)="open(task.token)">
            <p>
              <span class="is-capitalized"
                ><i
                  class="fa"
                  [class.fa-capsules]="task.info.target === 'drug'"
                  [class.fa-crosshairs]="task.info.target === 'drug-target'"
                  [class.fa-tasks]="task.info.target === 'summarize'"
                ></i>
                {{ algorithmNames[task.info.algorithm] }}</span
              >
            </p>
            <p>
              <small>Finished {{ task.info.finishedAt | date: "short" }}</small>
            </p>
          </div>

          <div class="column is-1">
            <span class="icon is-pulled-right"
              ><i class="fas fa-check" aria-hidden="true"></i
            ></span>
            <a
              (click)="analysis.removeTask(task.token)"
              class="is-pulled-right has-text-danger"
            >
              <span class="icon is-pulled-right">
                <i class="fa fa-trash"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div *ngIf="task.info.failed">
        <p>
          <span class="is-capitalized"
            ><i
              class="fa"
              [class.fa-capsules]="task.info.target === 'drug'"
              [class.fa-crosshairs]="task.info.target === 'drug-target'"
              [class.fa-tasks]="task.info.target === 'summarize'"
            ></i>
            {{ algorithmNames[task.info.algorithm] }}</span
          >
          <span class="icon is-pulled-right"
            ><i class="fas fa-exclamation-triangle" aria-hidden="true"></i
          ></span>
        </p>
        <p class="has-text-danger">
          <small class="status-field">{{ task.info.status }}</small>
          <a
            (click)="analysis.removeTask(task.token)"
            class="is-pulled-right has-text-danger"
          >
            <span class="icon is-pulled-right">
              <i class="fa fa-trash"></i>
            </span>
          </a>
        </p>
      </div>
    </a>
  </div>
</div>
